import React from 'react'
import PropTypes from 'prop-types'
import { Grid, Row, Col, Panel } from 'react-bootstrap'

export const View = ({ users, completedAllocations, skippedAllocations, realAllocations }) => {
	return <Grid>
		<Row className="show-grid">
			<Col md={3} sm={6} xs={12}>
				<Panel>
					<Panel.Body>
						<h5 className="text-center mt-0">Registered Users: </h5>
						<p className="text-center text-primary"><strong>{users}</strong></p>
					</Panel.Body>
				</Panel>
			</Col>
			<Col md={3} sm={6} xs={12}>
				<Panel>
					<Panel.Body>
						<h5 className="text-center mt-0">Virtual allocations made: </h5>
						<p className="text-center text-primary"><strong>{completedAllocations}</strong></p>
					</Panel.Body>
				</Panel>
			</Col>
			<Col md={3} sm={6} xs={12}>
				<Panel>
					<Panel.Body>
						<h5 className="text-center mt-0">Virtual allocations skipped: </h5>
						<p className="text-center text-primary"><strong>{skippedAllocations}</strong></p>
					</Panel.Body>
				</Panel>
			</Col>
			<Col md={3} sm={6} xs={12}>
				<Panel>
					<Panel.Body>
						<h5 className="text-center mt-0">Allocations carried out for real: </h5>
						<p className="text-center text-primary"><strong>{realAllocations}</strong></p>
					</Panel.Body>
				</Panel>
			</Col>
		</Row>
	</Grid>
}

View.propTypes = {
	users: PropTypes.number,
	completedAllocations: PropTypes.number,
	skippedAllocations: PropTypes.number,
	realAllocations: PropTypes.number
}

export default View


// WEBPACK FOOTER //
// ./src/routes/Home/components/View.js